import type { SKANPostbacksConversionMappingState } from './SKANPostbacksConversionMapping.types';

export const INIT_STATE: SKANPostbacksConversionMappingState = {
  mappingLoading: true,
  targetEventsLoading: true,
  processing: false,
  error: null,
  savedMapping: {},
  currentMapping: {},
  savedTargetEvent: '',
  currentTargetEvent: '',
  skAdNetworkEnabled: null,
  targetEventsRecommendations: [],
  savedAscendingOnly: undefined,
  currentAscendingOnly: undefined,
  templateOptions: [],
  activeTemplateId: null,
  lastUpdate: null,
};
